module.exports = __webpack_public_path__ + "static/media/shop-1.56665f7b.jpg";